import React from 'react';
import PropTypes from 'prop-types';
import utils from 'helpers/utils';
import pure from 'recompose/pure';
import translate from 'components/hoc/translate';

const TextField = (props) => {
    const {
        appendText,
        format,
        maxCharacters,
        source,
        translate,
        valueTranslationPrefix,
        record = {},
        elStyle,
    } = props;

    let text = utils.get(record, source);

    if (text) {
        if (format && utils.isFunction(format)) {
            text = format(text);
        }

        if (valueTranslationPrefix) {
            text = translate(`${ valueTranslationPrefix }.${ text }`);
        }

        if (maxCharacters) {

            /**
             * This function slices the amount of characters defined by the maxCharacters.
             *
             * @param {string} text
             * @param {number} maxCharacters
             */
            const formatMaxCharacters = (text, maxCharacters) => {
                return text.slice(0, maxCharacters) + (text.length > maxCharacters ? '...' : '');
            };

            text = formatMaxCharacters(text, maxCharacters);
        }

        if (appendText) {

            /**
             * This function appends texts at the end of the line.
             *
             * @param {string} text
             * @param {number} appendText
             */
            const addTextAtTheEnd = (text, appendText) => {
                return `${ text } ${ appendText }`;
            };

            text = addTextAtTheEnd(text, appendText);
        }
    }

    return <span style={ elStyle }>{ text }</span>;
};

TextField.propTypes = {
    appendText: PropTypes.string,
    format: PropTypes.func,
    elStyle: PropTypes.object,
    maxCharacters: PropTypes.number,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
    translate: PropTypes.func,
    valueTranslationPrefix: PropTypes.string,
};

const PureTextField = pure(translate(TextField));

PureTextField.defaultProps = {
    addLabel: true,
};

export default PureTextField;



// WEBPACK FOOTER //
// ./src/components/field/TextField.js